var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonalFrequent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Plans/Frequent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 29.9996 0 29.9996 15.938 0 15.938"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Plans/Frequent",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(-0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6154,7.9647 C24.3284,7.9647 24.0464,7.8337 23.8624,7.5857 C23.5534,7.1697 23.6394,6.5827 24.0564,6.2747 L25.3034,5.3477 C25.7184,5.0387 26.3054,5.1257 26.6154,5.5427 C26.9234,5.9577 26.8374,6.5447 26.4204,6.8537 L25.1734,7.7797 C25.0054,7.9047 24.8094,7.9647 24.6154,7.9647",
    id: "Fill-1",
    fill: "#FF7822"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4059,3.7267 C12.0229,3.7267 11.6639,3.4907 11.5249,3.1097 L11.0219,1.7267 C10.8439,1.2397 11.0949,0.7017 11.5819,0.5247 C12.0659,0.3477 12.6069,0.5997 12.7829,1.0857 L13.2869,2.4687 C13.4639,2.9547 13.2129,3.4937 12.7259,3.6697 C12.6209,3.7087 12.5119,3.7267 12.4059,3.7267",
    id: "Fill-3",
    fill: "#FF7822"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5933,3.7267 C17.4863,3.7267 17.3783,3.7087 17.2723,3.6697 C16.7863,3.4927 16.5353,2.9537 16.7123,2.4677 L17.2173,1.0847 C17.3933,0.5987 17.9323,0.3487 18.4193,0.5247 C18.9053,0.7027 19.1563,1.2397 18.9783,1.7267 L18.4743,3.1107 C18.3353,3.4907 17.9763,3.7267 17.5933,3.7267",
    id: "Fill-5",
    fill: "#FF7822"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.6371,
    y1: 10.6087,
    x2: 2.9941,
    y2: 11.2997,
    id: "Stroke-7",
    stroke: "#FF7822",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3509,7.9647 C5.1569,7.9647 4.9609,7.9047 4.7929,7.7797 L3.5449,6.8537 C3.1289,6.5447 3.0419,5.9577 3.3509,5.5427 C3.6599,5.1267 4.2479,5.0397 4.6619,5.3477 L5.9099,6.2747 C6.3259,6.5827 6.4129,7.1697 6.1039,7.5857 C5.9199,7.8337 5.6379,7.9647 5.3509,7.9647",
    id: "Fill-9",
    fill: "#FF7822"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.224,14.063 C25.946,10.713 24.198,7.781 21.628,5.903 L22.782,4.451 C25.781,6.669 27.812,10.125 28.092,14.063 L26.224,14.063 Z M9.986,4.92 L8.809,3.439 C10.655,2.446 12.761,1.875 15,1.875 C17.239,1.875 19.344,2.446 21.191,3.439 L20.014,4.92 C18.501,4.164 16.802,3.729 15,3.729 C13.197,3.729 11.499,4.164 9.986,4.92 L9.986,4.92 Z M3.775,14.063 L1.908,14.063 C2.187,10.124 4.219,6.669 7.218,4.451 L8.372,5.903 C5.801,7.781 4.053,10.713 3.775,14.063 L3.775,14.063 Z M15,12.093 C15.459,12.093 15.834,12.466 15.834,12.926 C15.834,13.386 15.459,13.76 15,13.76 C14.54,13.76 14.167,13.386 14.167,12.926 C14.167,12.466 14.54,12.093 15,12.093 L15,12.093 Z M23.236,2.478 C23.219,2.462 23.211,2.441 23.193,2.427 C23.115,2.365 23.026,2.33 22.938,2.297 C20.632,0.851 17.916,0 15,0 C12.083,0 9.368,0.85 7.062,2.296 C6.974,2.33 6.885,2.365 6.807,2.427 C6.79,2.441 6.782,2.462 6.765,2.477 C2.695,5.162 0,9.77 0,15 C0,15.519 0.419,15.938 0.937,15.938 L19.973,15.938 C20.491,15.938 20.91,15.519 20.91,15 C20.91,14.482 20.491,14.063 19.973,14.063 L17.45,14.063 C17.612,13.716 17.709,13.333 17.709,12.926 C17.709,11.433 16.494,10.218 15,10.218 C13.506,10.218 12.292,11.433 12.292,12.926 C12.292,13.333 12.388,13.716 12.55,14.063 L5.65,14.063 C6.122,9.32 10.134,5.604 15,5.604 C19.865,5.604 23.877,9.32 24.349,14.063 L23.367,14.063 C22.848,14.063 22.429,14.482 22.429,15 C22.429,15.519 22.848,15.938 23.367,15.938 L29.062,15.938 C29.58,15.938 30,15.519 30,15 C30,9.771 27.305,5.164 23.236,2.478 L23.236,2.478 Z",
    id: "Fill-11",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.9996,13.8634 C14.6076,13.8634 14.2426,13.6164 14.1106,13.2244 C13.9456,12.7334 14.2106,12.2014 14.7016,12.0374 L25.0356,8.5674 C25.5266,8.4034 26.0586,8.6664 26.2226,9.1574 C26.3876,9.6484 26.1236,10.1804 25.6326,10.3454 L15.2976,13.8144 C15.1996,13.8474 15.0986,13.8634 14.9996,13.8634",
    id: "Fill-14",
    fill: "#FF7822"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalFrequent);
export default __webpack_public_path__ + "static/media/personal_frequent.cedbb5883d3b9b638e87c594fdc29e70.svg";
export { ForwardRef as ReactComponent };